/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import { Link } from 'react-router-dom';

class StockTwitsOptions extends React.Component {
    render() {
        let currentPanel = null,
            visibleSettings = null,
            postTitle = (parseInt(this.props.getParamValue('postTitle'), 10)) ? true : false,
            postBody = (parseInt(this.props.getParamValue('postBody'), 10)) ? true : false,
            postUrl = (parseInt(this.props.getParamValue('postUrl'), 10)) ? true : false,
            postImages = (parseInt(this.props.getParamValue('postImages'), 10)) ? true : false,
            prefixSpace = (parseInt(this.props.getParamValue('prefixSpace'), 10)) ? true : false,
            postfixSpace = (parseInt(this.props.getParamValue('postfixSpace'), 10)) ? true : false,
            autoSentiment = (parseInt(this.props.getParamValue('autoSentiment'), 10)) ? true : false,
            socialStats = (parseInt(this.props.getParamValue('socialStats'), 10)) ? true : false,
            statusLabel = this.props.getParamStateLabel('autoSentiment'),
            controlState = this.props.getControlState();

        if (this.props.activePanel !== 'advanced') {
            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {this.props.getPostTitle(postTitle)}
                            {this.props.getPostBody(postBody)}
                            {this.props.getPostUrl(postUrl)}
                            {this.props.getPostPhoto(postImages)}
                        </div>
                    )
                }
            } else {
                visibleSettings = (
                    <div>
                        {this.props.getPostTitle(postTitle)}
                        {this.props.getPostBody(postBody)}
                        {this.props.getPostUrl(postUrl)}
                        {this.props.getPostPhoto(postImages)}
                    </div>
                )
            }

            currentPanel = (
                <div>
                    {visibleSettings}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        } else {
            currentPanel = (
                <div>
                    <fieldset>
                        <legend>Auto Sentiment{statusLabel}<HelpButton which="autoSentiment" /></legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="params.autoSentiment" errors={state.errors} />
                                );
                            }} />
                        <Toggle
                            active={autoSentiment}
                            noLabel={true}
                            callback={this.props.changeHandler}
                            linkedField="social.params.autoSentiment"
                            controlState={controlState} />
                    </fieldset>
                    {this.props.getSocialStats(socialStats)}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(StockTwitsOptions);
